import InjuredParty from '../../shared/InjuredParty'
import type { Step3InjuredPartyProps } from '@/features/enrollment'

/**
 * Step 1: Injured Party Information
 * Wrapper for shared InjuredParty component
 */
export default function Step1_InjuredParty(props: Step3InjuredPartyProps) {
  const { totalSteps = 10, ...restProps } = props

  return (
    <InjuredParty
      {...restProps}
      useStageWrapper
      totalSteps={totalSteps}
    />
  )
}
